import { toFixedExact } from '../../../../core/services/utils/numbers';
import { AliquotasDRP } from '../aliquotas';
import { DRP } from '../drp';
import { PedidoItemDRP } from '../item';
import { IGruposRentabilidadeResponse } from '../../../../domains/core/settings/grupos-rentabilidade/interfaces/grupos-rentabilidade-response.interface';
import { getGrupoRentabilidadeByMargem } from '../../../../domains/shared/utils/grupos-rentabilidade/grupo-rentabilidade.util';

export class PedidoDRP extends DRP {
    itens: PedidoItemDRP[];
    aliquotas: AliquotasDRP;
		gruposRentabilidade: IGruposRentabilidadeResponse[] | null = null;

	// Não Liberado
	valorLucroLiquidoNaoLiberado: number;
	percLucroLiquidoNaoLiberado: number;
	percLucroLiquidoMinimoNaoLiberado: number;
	liberadoManualmenteLucroLiquidoAbaixo: boolean;
	dataLiberadoLucroLiquidoAbaixo: Date;
	idUsuarioLiberadoLucroLiquidoAbaixo: number;
	nomeUsuarioLiberadoLucroLiquidoAbaixo: string;
	avatarURLUsuarioLiberadoLucroLiquidoAbaixo: string;
	justificativaLiberadoLucroLiquidoAbaixo: string;

	/* Obtem o percentual minímo do lucro líquido */
	getPercLucroLiquidoMinimo(): number {
		return this.aliquotas?.percLucroLiquidoMinimo ?? 0;
	}

    gerar(itens: PedidoItemDRP[]) {
        // Gerando e totalizando os DRPs dos itens do pedido
    	let valorTotalBrutoItens = 0;
    	let valorIcmsItens = 0;
		let baseCalculoPisItens = 0;
    	let valorPisItens = 0;
		let baseCalculoCofinsItens = 0;
    	let valorCofinsItens = 0;
    	let valorDvvFreteItens = 0;
    	let valorRoyaltiesItens = 0;
    	let valorIpiItens = 0;
    	let valorComissaoItens = 0;
    	let custoVariavelTotalItens = 0;
    	let valorMargemContribuicaoItens = 0;
    	let custoFixoTotalItens = 0;
    	let valorMarketingItens = 0;
    	let valorDespesaAdministrativaItens = 0;
    	let valorPerdaDevolucaoItens = 0;
    	let valorOutrosItens = 0;
    	let valorCustoFinanceiroItens = 0;
    	let valorDescontoContratoItens = 0;
    	let valorIrItens = 0;
    	let valorContribuicaoSocialItens = 0;

		this.itens = itens;
        this.itens?.forEach((item) => {
            valorTotalBrutoItens += item.valorTotalBruto;
            valorIcmsItens += item.valorIcms;
			baseCalculoPisItens += item.baseCalculoPis;
            valorPisItens += item.valorPis;
			baseCalculoCofinsItens += item.baseCalculoCofins;
            valorCofinsItens += item.valorCofins;
            valorDvvFreteItens += item.valorDvvFrete;
            valorRoyaltiesItens += item.valorRoyalties;
            valorIpiItens += item.valorIpi;
            valorComissaoItens += item.valorComissao;
            custoVariavelTotalItens += item.custoVariavelTotal;
            valorMargemContribuicaoItens += item.valorMargemContribuicao;
            custoFixoTotalItens += item.custoFixoTotal;
            valorMarketingItens += item.valorMarketing;
            valorDespesaAdministrativaItens += item.valorDespesaAdministrativa;
            valorPerdaDevolucaoItens += item.valorPerdaDevolucao;
            valorOutrosItens += item.valorOutros;
            valorCustoFinanceiroItens += item.valorCustoFinanceiro;
            valorDescontoContratoItens += item.valorDescontoContrato;
            valorIrItens += item.valorIr;
            valorContribuicaoSocialItens += item.valorContribuicaoSocial;
        })

    	/*** 1. TOTAL BRUTO ***/
    	this.valorTotalBruto = toFixedExact(valorTotalBrutoItens, 4);

    	/** DVVs 1 = ICMS + PIS + COFINS + Frete + Perda e Devolução + Custo Financeiro + Desconto em Contrato **/
    	// ICMS
    	this.valorIcms = toFixedExact(valorIcmsItens, 4);
    	this.calcularPercAliquotaIcms();
    	// PIS
		this.baseCalculoPis = toFixedExact(baseCalculoPisItens, 4);
    	this.valorPis = toFixedExact(valorPisItens, 4);
    	this.calcularPercAliquotaPis();
    	this.calcularPercPisComposicao();
    	// COFINS
		this.baseCalculoCofins = toFixedExact(baseCalculoCofinsItens, 4);
    	this.valorCofins = toFixedExact(valorCofinsItens, 4);
    	this.calcularPercAliquotaCofins();
    	this.calcularPercCofinsComposicao();

    	// Frete
    	this.valorDvvFrete = toFixedExact(valorDvvFreteItens, 4);
    	this.calcularPercDvvFrete();

    	// Perdas e Devoluções
    	this.valorPerdaDevolucao = toFixedExact(valorPerdaDevolucaoItens, 4);
    	this.calcularPercPerdaDevolucao();

    	// Custo Financeiro
    	this.valorCustoFinanceiro = toFixedExact(valorCustoFinanceiroItens, 4);
    	this.calcularPercCustoFinanceiro();

    	// Desconto em Contrato
    	this.valorDescontoContrato = toFixedExact(valorDescontoContratoItens, 4);
    	this.calcularPercDescontoContrato();

    	// Total DVV's 1
    	this.somarValorDvvs1();
    	this.calcularPercDvvs1();

    	// Royalties
    	this.valorRoyalties = toFixedExact(valorRoyaltiesItens, 4);
    	this.calcularPercRoyalties();

    	// IPI
    	this.valorIpi = toFixedExact(valorIpiItens, 4);
    	this.calcularPercAliquotaIpi();

    	// Comissão
    	this.valorComissao = toFixedExact(valorComissaoItens, 4);
    	this.calcularPercComissao();

    	/*** 2. (-) DVV's (DVV's 1 + Royalties + IPI + Comissão) ***/
    	this.somarPercDvvs();
    	this.somarValorDvvs();
    	this.calcularPercDvvsComposicao();

    	/*** 3. (=) TOTAL LÍQUIDO ***/
    	this.calcularValorTotalLiquido();

    	/*** 4. CUSTO MATÉRIA PRIMA ***/
    	this.custoVariavelTotal = toFixedExact(custoVariavelTotalItens, 4);
    	this.calcularPercCustoVariavel();
    	this.calcularPercCustoVariavelComposicao();

    	/*** 5. (=) MARGEM DE CONTRIBUIÇÃO **/
    	this.valorMargemContribuicao = toFixedExact(valorMargemContribuicaoItens, 4);
    	this.calcularPercMargemContribuicao();
    	this.calcularPercMargemContribuicaoComposicao();

    	/*** 5.1. (-) CUSTO DIRETO ***/
    	this.custoFixoTotal = toFixedExact(custoFixoTotalItens, 4);
    	this.calcularPercCustoFixo();
    	this.calcularPercCustoFixoComposicao();

    	/** Custo Indireto = Marketing + ADM + Outros **/
    	// Marketing
    	this.valorMarketing = toFixedExact(valorMarketingItens, 4);
    	this.calcularPercMarketing();
    	this.calcularPercMarketingParticipacao();
    	// Despesas Administrativas
    	this.valorDespesaAdministrativa = toFixedExact(valorDespesaAdministrativaItens, 4);
    	this.calcularPercDespesaAdministrativa();
    	this.calcularPercDespesaAdministrativaParticipacao();
    	// Outros
    	this.valorOutros = toFixedExact(valorOutrosItens, 4);
    	this.calcularPercOutros();
    	this.calcularPercOutrosParticipacao();

    	/*** 5.2. (-) CUSTO INDIRETO (Marketing + Despesas Administrativas + Outros) ***/
    	this.somarPercCustoIndireto();
    	this.somarValorCustoIndireto();
    	this.calcularPercCustoIndiretoParticipacao();
    	this.calcularPercCustoIndiretoComposicao();

    	/*** 6. (=) RESULTADO LÍQUIDO ***/
    	this.calcularValorResultadoLiquidoTotal();
    	this.calcularPercResultadoLiquidoTotal();
    	this.calcularPercResultadoLiquidoTotalComposicao();

    	/*** 7. (-) IR/CSLL ***/
    	// IR
    	this.valorIr = toFixedExact(valorIrItens, 4);
    	this.calcularPercIr();
    	this.calcularPercIrParticipacao();
    	// CSLL (Contribuição Social)
    	this.valorContribuicaoSocial = toFixedExact(valorContribuicaoSocialItens, 4);
    	this.calcularPercContribuicaoSocial();
    	this.calcularPercContribuicaoSocialParticipacao();
    	// IR (Imposto de Renda) + CSLL (Contribuição Social)
    	this.somarPercIrContribuicaoSocial();
    	this.somarValorIrContribuicaoSocial();
    	this.calcularPercIrContribuicaoSocialParticipacao();
    	this.calcularPercIrContribuicaoSocialComposicao();

    	/*** 8. (=) LUCRO LÍQUIDO ***/
    	this.calcularValorLucroLiquido();
    	this.calcularPercLucroLiquido();
    	this.calcularPercLucroLiquidoComposicao();
    	this.percLucroLiquidoMinimo = this.getPercLucroLiquidoMinimo();
    	this.percLucroLiquidoAbaixo = this.percLucroLiquido < this.percLucroLiquidoMinimo;

			/** Composições derivadas — dependem dos valores já apurados **/
			this.calcularComposicoesDerivadas();

			/*** 9. QUALIDADE DE VALOR (QV) ***/
			// Classificar o grupo de rentabilidade com base no lucro líquido calculado
			const grupoRentabilidade = getGrupoRentabilidadeByMargem(this.gruposRentabilidade ?? [], this.percLucroLiquido);
			if (grupoRentabilidade) {
				this.idGrupoRentabilidade = grupoRentabilidade.id;
				this.nomeGrupoRentabilidade = grupoRentabilidade.nome;
				this.escalaGrupoRentabilidade = grupoRentabilidade.escala;
				this.escalaSimboloGrupoRentabilidade = grupoRentabilidade.escalaSimbolo;
			}
    }
}
